import { z } from "zod";

export const loginSchema = z.object({
	email: z
		.string()
		.min(1, { message: "form.email.min" })
		.email({ message: "form.email.valid" }),
	password: z.string().min(1, { message: "form.password.min" }),
	isLdap: z.boolean().optional(),
});

export type LoginForm = z.infer<typeof loginSchema>;
export type EmailField = LoginForm["email"];
export type PasswordField = LoginForm["password"];
